import { render } from "./CreateWhatsNew.vue?vue&type=template&id=754c9009&scoped=true"
import script from "./CreateWhatsNew.vue?vue&type=script&lang=js"
export * from "./CreateWhatsNew.vue?vue&type=script&lang=js"

import "./CreateWhatsNew.vue?vue&type=style&index=0&id=754c9009&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754c9009"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField});
